import React from "react";
import SVG from "react-inlinesvg";
import { Modal } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { formatAmount, formatDate, formatStatus } from "../../../../util/Helpers";

const ViewPortfolioCreationModal = ({ showViewPortfolioCreationModal, details, onHide }) => {
    return (
        <Modal
            show={showViewPortfolioCreationModal}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
        >

            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                        <SVG
                            title=""
                            src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart3.svg")}
                        />
                    </span>
                    Portfolio Creation Details
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Modal.Body
                className="px-10 py-2"
            >
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>ID</h6>
                        <span className="text-muted">{details?.id}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>User ID</h6>
                        <span className="text-muted">{details?.userId}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Account ID</h6>
                        <span className="text-muted">{details?.accountId}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>Payment Status</h6>
                        <span className="text-muted">{formatStatus(details?.paymentStatus)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Status</h6>
                        <span className="text-muted">{formatStatus(details?.status)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Status Comment</h6>
                        <span className="text-muted">{details?.statusComment}</span>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg py-4">
                        <h6>Account Created</h6>
                        <span className="text-muted">{(!!details?.accountCreated).toString()}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Partner</h6>
                        <span className="text-muted">{details?.partner}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Amount</h6>
                        <span className="text-muted">{formatAmount(details?.currency, details?.amount)}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>Amount Fund ID</h6>
                        <span className="text-muted">{details?.accountFundId}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Amount Funded</h6>
                        <span className="text-muted">{formatAmount(details?.currency, details?.amountFunded)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Rate</h6>
                        <span className="text-muted">{details?.rate}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg py-4">
                        <h6>Created</h6>
                        <span className="text-muted">{formatDate(details?.created)}</span>
                    </div>
                    <div className="col-lg py-4">
                        <h6>Updated</h6>
                        <span className="text-muted">{formatDate(details?.updated)}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg">
                        <h4 className="mb-4 mt-5 text-muted h5">More Details</h4>
                        <div className="text-muted bg-light-secondary rounded-lg p-4 overflow-auto" style={{ maxHeight: "300px" }}>
                            <pre className="mb-0">{JSON.stringify(JSON.parse(details?.meta || "{}"), null, 4)}</pre>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <button
                    type="button"
                    onClick={onHide}
                    className="btn btn-primary btn-elevate px-4"
                >
                    Okay
                </button>
            </Modal.Footer>
        </Modal>

    );
}

export default ViewPortfolioCreationModal;